//Contact Form Floating Labels
const inputs = document.querySelectorAll('.form__floating input')
if (inputs) {
    inputs.forEach(input => {
        input.addEventListener('focus', () => {
            input.classList.add('active')
        })
        input.addEventListener('blur', () => {
            if (input.value == '') {
                input.classList.remove('active')
            }
        })
    })
}